/*
    Keep the standard MIME types (IANA media types)
*/
const ContentType = Object.freeze({
  XLS: { mime: 'application/xls', fileExt: 'xls' },
  CSV: { mime: 'text/csv', fileExt: 'csv' },
})

export default ContentType
